import React, { Component } from 'react';
import { compose } from 'utils/compose';
import { inject, observer } from 'mobx-react';

import { Box, DialogContent, DialogTitle, Grid } from '@mui/material';

import ButtonSelectBox from 'components/ButtonSelectBox';
import { DialogFooter, DialogActionButton } from 'components/Dialog';

import withMediaQuery from 'constants/mediaQuery';

import { useStyles } from './styles';

// HOC to inject styles into class component
// no-dd-sa:javascript-code-style/parameter-name
const withUseStyles = (WrappedComponent) => {
  return function WithStylesWrapper(props) {
    const classes = useStyles();
    return <WrappedComponent {...props} classes={classes} />;
  };
};

class EditSignatureOptionDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      signature_required: false,
    };
  }

  componentDidMount() {
    const { delivery, editedDeliveryData } = this.props.store.deliveryStore;
    const { shipment } = delivery;

    this.setState({
      signature_required: editedDeliveryData.signature_required || shipment.signature_required,
    });
  }

  onChange = (value) => {
    this.setState({ signature_required: value });
  };

  save = () => {
    const { deliveryStore } = this.props.store;
    const { signature_required } = this.state;

    deliveryStore.setEditedDeliveryField('signature_required', signature_required);
    deliveryStore.saveAndCloseDialog();
  };

  render() {
    const { classes, store, mediaQuery } = this.props;
    const { deliveryStore } = store;
    const { delivery, tokenRemainingTimeString } = deliveryStore;

    if (!delivery) return null;

    const options = [
      { label: 'No-Touch Delivery', value: true },
      { label: 'Not Required', value: false },
    ];

    return (
      <Box sx={classes.container}>
        <DialogTitle>
          <Grid
            container
            justifyContent="space-between"
            alignItems={mediaQuery.isMobile ? 'flex-start' : 'center'}
            direction={mediaQuery.isMobile ? 'column' : 'row'}
            spacing={mediaQuery.isMobile ? 1 : 0}
          >
            <Grid sx={classes.dialogTitle}>
              <span style={{ fontWeight: 600 }}>Signature Option</span>
            </Grid>
            <Grid sx={classes.dialogTimer}>
              <Box component="span" sx={classes.underlined}>
                Session time:
              </Box>
              <Box component="span" sx={classes.timerCounter}>
                {tokenRemainingTimeString}
              </Box>
            </Grid>
          </Grid>
          <Box pt={2} pb={mediaQuery.isMobile ? 1 : 3} sx={classes.noticeSignatureBox}>
            - To have your signature collected remotely on your device, choose <span style={{ fontWeight: 600 }}>“No-touch Delivery”</span>.<br />- To
            opt-out your signature and have the delivery left at the door, choose <span style={{ fontWeight: 600 }}>“Not Required”</span>.
          </Box>
        </DialogTitle>
        <DialogContent>
          <ButtonSelectBox value={this.state.signature_required} onChange={this.onChange} options={options} title="Signature Option:" />
        </DialogContent>
        <DialogFooter>
          <DialogActionButton onClick={() => deliveryStore.closeEditDialog()} variant="outlined" disableElevation>
            Cancel
          </DialogActionButton>
          <DialogActionButton onClick={this.save} variant="contained" color="primary" disableElevation>
            Save
          </DialogActionButton>
        </DialogFooter>
      </Box>
    );
  }
}

const EditSignatureOptionDialogCompose = compose(inject('store'), observer)(EditSignatureOptionDialog);

export default withUseStyles(withMediaQuery()(EditSignatureOptionDialogCompose));
